/**
 * Theoretical-vs-actual weight check (§14.1). Tolerance band is the larger of a
 * percentage of expected and an absolute gram floor:
 *   toleranceG = max(round(expected * percent/100), floorGrams)
 * Expected = itemsWeightG + boxTareG (caller sums it). Pure.
 */
import type { WeightFlag } from "@cairn/shared";
import type { WeightCheckResult, WeightTolerance } from "../types.js";

export function checkWeight(
  expectedG: number,
  actualG: number,
  tolerance: WeightTolerance,
): WeightCheckResult {
  const pct = Math.round((expectedG * tolerance.percent) / 100);
  const toleranceG = Math.max(pct, tolerance.floorGrams);
  const deltaG = actualG - expectedG;
  const deltaPercent = expectedG > 0 ? (deltaG / expectedG) * 100 : 0;
  const withinTolerance = Math.abs(deltaG) <= toleranceG;

  let flag: WeightFlag;
  if (withinTolerance) flag = "OK";
  else if (deltaG < 0) flag = "UNDER";
  else flag = "OVER";

  return { flag, withinTolerance, expectedG, actualG, deltaG, deltaPercent, toleranceG };
}
